// Cycle 11 followup-5 Commit E (2026-05-17) — read the storefront-i18n
// window-bridge JSON so on-page badge text / currency formatting honour
// motor.dil instead of the legacy TR / TL hardcodes. The bridge is
// emitted by `snippets/ecomnodes-storefront-i18n.liquid` and populated by
// Phase F section-builders. Missing / malformed bridge falls back to a
// neutral English default so the UI never shows TR copy on a non-TR
// storefront.
function __ecomnodesReadStorefrontI18n() {
  try {
    var node = document.getElementById('ecomnodes-storefront-i18n');
    if (!node) return {};
    var parsed = JSON.parse(node.textContent || '{}');
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (e) {
    return {};
  }
}

if (!customElements.get('bundle-selector')) {
  customElements.define('bundle-selector', class BundleSelector extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.dataEl = this.querySelector(`#bundle-data-${this.sectionId}`);
      if (!this.dataEl) return;

      this.config = JSON.parse(this.dataEl.textContent);
      this.i18n = __ecomnodesReadStorefrontI18n();
      this.radios = this.querySelectorAll('input[name="bundle-select"]');
      this.priceEl = document.querySelector('.phero__price');
      this.compareEl = document.querySelector('.phero__compare');
      this.badgeEl = document.querySelector('.phero__discount-badge');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitBtn = this.querySelector('.phero__cart-btn');
      this.formEl = this.querySelector('form#product-form-hero');

      // Disable product-form.js default handler
      const productFormCE = this.querySelector('product-form');
      if (productFormCE) {
        const oldBtn = this.submitBtn;
        if (oldBtn) {
          const newBtn = oldBtn.cloneNode(true);
          oldBtn.parentNode.replaceChild(newBtn, oldBtn);
          this.submitBtn = newBtn;
        }
      }

      if (this.formEl) {
        this.formEl.addEventListener('submit', (e) => {
          e.preventDefault();
          e.stopPropagation();
        }, true);
      }

      if (this.submitBtn) {
        this.submitBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.onSubmit();
        });
      }

      this.radios.forEach(r => r.addEventListener('change', this.onSelect.bind(this)));

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
          if (evt.data?.variant?.id) {
            this.config.productVariantId = evt.data.variant.id;
            this.config.productPrice = evt.data.variant.price;
            if (this.formEl) {
              const inp = this.formEl.querySelector('[name="id"]');
              if (inp) inp.value = evt.data.variant.id;
            }
            const checked = this.querySelector('input[name="bundle-select"]:checked');
            if (checked) this.onSelect({ target: checked });
          }
        });
      }

      const initial = this.querySelector('input[name="bundle-select"]:checked');
      if (initial) this.onSelect({ target: initial });
    }

    getBundle(index) {
      return this.config.bundles[index] || null;
    }

    onSelect(evt) {
      const idx = parseInt(evt.target.value, 10);
      const bundle = this.getBundle(idx);
      if (!bundle) return;

      this.querySelectorAll('.bcard').forEach((c, i) => {
        c.classList.toggle('bcard--selected', i === idx);
      });

      const mainTotal = this.config.productPrice * bundle.mainQuantity;
      let bundleDiscount = 0;
      if (bundle.discountType === 'percent' && bundle.discountValue > 0) {
        bundleDiscount = Math.round(mainTotal * bundle.discountValue / 100);
      } else if (bundle.discountType === 'fixed' && bundle.discountValue > 0) {
        bundleDiscount = bundle.discountValue * 100;
      }
      const finalPrice = Math.max(0, mainTotal - bundleDiscount);

      const retailCompare = (this.config.productComparePrice || 0) * bundle.mainQuantity;
      const compare = Math.max(retailCompare, mainTotal);
      const hasDiscount = compare > finalPrice;

      if (this.priceEl) this.priceEl.textContent = this.formatMoney(finalPrice);
      if (this.compareEl) {
        if (hasDiscount) {
          this.compareEl.textContent = this.formatMoney(compare);
          this.compareEl.style.display = '';
        } else {
          this.compareEl.style.display = 'none';
        }
      }
      if (this.badgeEl) {
        if (hasDiscount) {
          const discountPct = Math.round(((compare - finalPrice) / compare) * 100);
          // Cycle 11 followup-5 Commit E (2026-05-17): label + format come
          // from window-bridge i18n. Server-side Liquid populates
          // `config.badgeText` from `block.settings.badge_text` (Phase D
          // priceLabel) when present, with section.settings.discount_label_fallback
          // as the per-dil fallback. Bare 'OFF' is the universal neutral
          // backstop for a missing bridge.
          const label = this.config.badgeText || this.i18n.discountLabel || 'OFF';
          // Format template: '-{pct}% {label}' (EN/DE/FR/IT/ES/NL) or
          // '%{pct} {label}' (TR). Template uses (pct) + (label) placeholders
          // for parity with the Liquid renderer that consumes the same
          // string in `i18n.storefront.discountBadgeTemplate`.
          const fmt = this.i18n.bundleBadgeFormat || '-(pct)% (label)';
          this.badgeEl.textContent = fmt
            .replace('(pct)', String(discountPct))
            .replace('(label)', label);
          this.badgeEl.style.display = '';
        } else {
          this.badgeEl.style.display = 'none';
        }
      }
    }

    showError(message) {
      let errorEl = this.querySelector('.phero__error');
      if (!errorEl) {
        errorEl = document.createElement('div');
        errorEl.className = 'phero__error';
        errorEl.setAttribute('role', 'alert');
        errorEl.setAttribute('aria-live', 'polite');
        const anchor = this.submitBtn && this.submitBtn.parentElement ? this.submitBtn : this;
        anchor.insertAdjacentElement('beforebegin', errorEl);
      }
      errorEl.textContent = message;
      errorEl.style.display = '';
      clearTimeout(this._errorTimer);
      this._errorTimer = setTimeout(() => { errorEl.style.display = 'none'; }, 4500);
    }

    setLoading(state) {
      if (!this.submitBtn) return;
      if (state) {
        this.submitBtn.setAttribute('disabled', 'disabled');
        this.submitBtn.classList.add('is-loading');
      } else {
        this.submitBtn.removeAttribute('disabled');
        this.submitBtn.classList.remove('is-loading');
      }
    }

    async onSubmit() {
      const checked = this.querySelector('input[name="bundle-select"]:checked');
      if (!checked) return;

      const bundle = this.getBundle(parseInt(checked.value, 10));
      if (!bundle) return;

      this.setLoading(true);

      const variantInput = this.formEl ? this.formEl.querySelector('[name="id"]') : null;
      const variantId = variantInput ? Number(variantInput.value) : this.config.productVariantId;

      if (!variantId || isNaN(variantId)) {
        this.showError('Lutfen bir beden/varyant secin.');
        this.setLoading(false);
        return;
      }

      try {
        // Step 1: Add main product with bundle info in properties
        const mainProps = {
          '_bundle_label': bundle.label
        };
        if (bundle.discountCode) {
          mainProps['_discount_code'] = bundle.discountCode;
        }
        await this.addSingleItem(variantId, bundle.mainQuantity, mainProps);

        // Step 2: Add gift items
        for (const gift of (bundle.gifts || [])) {
          if (gift.variantId) {
            await this.addSingleItem(gift.variantId, gift.quantity || 1, {
              '_is_bundle_gift': 'true',
              '_gift_label': gift.label || ''
            });
          }
        }

        // Step 3: Apply discount code if set
        if (bundle.discountCode) {
          await this.applyDiscountCode(bundle.discountCode);
        }

        // Success
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-selector' });
        }

        // If discount code exists, redirect through discount URL for guaranteed application
        if (bundle.discountCode) {
          window.location = '/discount/' + encodeURIComponent(bundle.discountCode) + '?redirect=/cart';
          return;
        }

        this.refreshCartUI();

      } catch (err) {
        console.error('Bundle add failed:', err);
        this.showError(err.message || 'Sepete eklenirken bir hata olustu. Lutfen tekrar deneyin.');
      } finally {
        this.setLoading(false);
      }
    }

    addSingleItem(id, quantity, properties) {
      const body = new FormData();
      body.append('id', id);
      body.append('quantity', quantity);
      if (properties && Object.keys(properties).length > 0) {
        for (const [key, val] of Object.entries(properties)) {
          body.append('properties[' + key + ']', val);
        }
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        body: body
      })
      .then(r => r.json())
      .then(data => {
        if (data.status && data.status >= 400) {
          throw new Error(data.description || data.message || 'Urun eklenemedi');
        }
        return data;
      });
    }

    applyDiscountCode(code) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code })
      })
      .then(r => {
        if (!r.ok) {
          console.error('Discount code apply failed:', code, 'HTTP', r.status);
        }
        return r.json();
      })
      .catch(err => {
        console.error('Discount code network error:', code, err);
      });
    }

    refreshCartUI() {
      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        try {
          const sectionIds = this.cart.getSectionsToRender().map(s => s.id).join(',');
          fetch('/cart?sections=' + sectionIds)
            .then(r => r.json())
            .then(sections => {
              if (sections && typeof this.cart.renderContents === 'function') {
                this.cart.renderContents({ sections: sections });
              }
            })
            .catch(() => {
              window.location = '/cart';
            });
        } catch (e) {
          window.location = '/cart';
        }
      } else {
        window.location = '/cart';
      }
    }

    formatMoney(cents) {
      // Cycle 11 followup-5 Commit E (2026-05-17): currency-agnostic
      // formatter. Primary source for the currency code is
      // `window.Shopify.currency.active` (per-page, set by Shopify); the
      // window-bridge i18n only contributes the locale tag for digit grouping
      // and the fallback currency code when Shopify hasn't injected one yet.
      // Replaces the previous `toLocaleString('tr-TR', …) + ' TL'` hardcode.
      var shop = (typeof window !== 'undefined' && window.Shopify && window.Shopify.currency) || null;
      var currencyCode = (shop && shop.active) || this.i18n.currencyCode || 'USD';
      var locale = this.i18n.intlLocale || 'en-US';
      var amount = cents / 100;
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currencyCode,
          maximumFractionDigits: 2,
        }).format(amount);
      } catch (e) {
        // Unknown ISO 4217 code or locale — fall back to a bare two-decimal
        // amount + ISO suffix so the storefront still renders a price.
        return amount.toFixed(2) + ' ' + currencyCode;
      }
    }
  });
}
